import { Inject, Injectable, Injector } from '@angular/core';
import * as configData from '../../../../public/assets/config/default.json'
import { Subject, forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { PluginConfig } from '../models/plugin-config';
import { PluginObject } from '../models/model';
import { PluginClassRegistry } from '../models/plugin-registry';
interface PluginMeta {
  configuration: PluginConfig;
  pluginPath: string;
}

@Injectable({
  providedIn: 'root'
})
export class PluginService {
  private pluginsDir = 'assets/plugins/';
  private config: any = configData;
  private allPlugins: Record<string, any> = {};
  private hiddenPlugins: PluginObject[] = [];
  private windowPlugins: PluginObject[] = [];
  private toolPlugins: PluginObject[] = [];
  private feedPlugins: PluginObject[] = [];
  private searchPlugins: PluginObject[] = [];
  private drawerPlugins: PluginObject[] = [];

  private pluginModules: any[] = [];

  private allPluginsLoaded$ = new Subject<void>();
  private initialized = false;
  private initPromise?: Promise<void>;

  constructor(
    private http: HttpClient,
    // @Inject('PluginObject') private PluginObjectCtor: any,
    private injector: Injector  // Avoid using `Injector` unless absolutely needed
  ) {

  }

  initialize(): Promise<void> {

    if (this.initialized)
      return this.initPromise!;

    this.initPromise = new Promise<void>((resolve, reject) => {

      const pluginPromises = this.config.plugins.map((plugin: any) =>
        this.calculateListOfModulesToLoad(`${this.pluginsDir}${plugin}`)
      );

      Promise.all(pluginPromises)
        .then(pluginObjects => {

          const loadPromises = pluginObjects.map(pluginObj => this.loadPlugin(pluginObj));
          return Promise.all(loadPromises);
        })
        .then(() => {
          this.setupPlugins();
          this.allPluginsLoaded$.next();
          this.initialized = true;
          resolve();
        })
        .catch(error => {
          console.error('Could not load plugins:', error);
          reject(error);
        });
    });

    return this.initPromise;
  }












  private calculateListOfModulesToLoad(pluginPath: string) {
    try {
      return this.http.get<PluginConfig>(`${pluginPath}/config.json`).toPromise().then(config => {
        this.allPlugins[config!.name] = {
          configuration: config,
          pluginPath: pluginPath
        };
        return {
          configuration: config,
          pluginPath: pluginPath
        };
      });

    }
    catch (error) {

      console.error('Could not load plugins:', error);
      return null;
    }
  }


  private loadPlugin(pluginObject: PluginMeta): Promise<void> {
    const { configuration } = pluginObject;

    const modules = configuration.modules || [];
    modules.forEach((module: any, i: number) => {
      module.pluginPath = pluginObject.pluginPath;
      this.pluginModules.push(module);
    });

    return Promise.resolve();
  }

  private setupPlugins() {
  try {
    this.pluginModules.forEach(pluginModule => {
      const factoryName = pluginModule.factory;
      const factoryPath = pluginModule.pluginPath + '/';
      const type = pluginModule.type;

      if (factoryName && type === 'feed') {
        const PluginClass = PluginClassRegistry[factoryName];
        if (PluginClass) {
          const pluginInstance = new PluginClass(); // Create real plugin instance
          this.feedPlugins.push(pluginInstance);
        } else {
        }
      }
    });
  } catch (error) {
    console.error('Error setting up plugins:', error);
  }
}

  private initializeHiddenPlugin(plugin: PluginObject) {
    const HiddenPluginClass = this.injector?.get(plugin.pluginName);
    const hiddenPlugin = new HiddenPluginClass();
    hiddenPlugin.initialize();
  }

  // Accessors
  getToolPlugins(): Promise<PluginObject[]> {
    return this.initialize().then(() => this.toolPlugins);
  }

  getWindowPlugins(): Promise<PluginObject[]> {
    return this.initialize().then(() => this.windowPlugins);
  }

  getSearchPlugins(): Promise<PluginObject[]> {
    return this.initialize().then(() => this.searchPlugins);
  }

  getFeedPlugins(): Promise<PluginObject[]> {
    return this.initialize().then(() => this.feedPlugins);
  }

  getDrawerPlugins(): Promise<PluginObject[]> {
    return this.initialize().then(() => this.drawerPlugins);
  }

  getAllImportedPlugins(): Promise<Record<string, any>> {
    return this.initialize().then(() => this.allPlugins);
  }

  onAllPluginsLoaded() {
    return this.allPluginsLoaded$.asObservable();
  }

}
